export default __webpack_public_path__ + "static/media/niki.75e7ac78.jpg";